<template>
  <div>
    <h1>Oops!</h1>
    <h3>{{ resource }} werd niet gevonden.</h3>
    <router-link :to="{ name: 'list' }">Terug naar homepage</router-link>
  </div>
</template>
<script>
export default {
  props: {
    resource: {
      type: String,
      required: true,
      default: "pagina"
    }
  }
};
</script>
